import { Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class ColumnSortService {
  private currentSort = new Subject<SortObj>();
  currentSort$ = this.currentSort.asObservable();
  publishData(data) {
    this.currentSort.next(data);
  }
}

interface SortObj {
  prop: string;
  dir: string;
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/column-sort/column-sort.service.ts